var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dial-gauge-wrapper"},[_c('h1',{directives:[{name:"show",rawName:"v-show",value:(_vm.displayValueHeader),expression:"displayValueHeader"}],staticClass:"text-center"},[_c('b',[_vm._v(_vm._s(_vm.value))])]),_vm._v(" "),_c('canvas',{ref:"gauge",attrs:{"id":"gauge"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }